import { useState } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'

const faqs = [
  {
    id: 1,
    question: 'When can I RSVP?',
    answer: 'You can RSVP now through this website! Please submit your RSVP by February 28, 2026. You can also update your response anytime before the deadline by returning to the RSVP page.',
  },
  {
    id: 2,
    question: 'Will there be a hotel block?',
    answer: 'We’re working on setting up a hotel block to help make your stay as smooth and enjoyable as possible. We’ll update this website with all the details as soon as they’re confirmed, so check back soon!',
  },
  {
    id: 3,
    question: 'Can I bring a date or plus one?',
    answer: 'Due to limited space and our hope to keep the celebration intimate, we’re only able to accommodate guests who are listed on the invitation. If you have a plus one, their name or “and guest” will appear when you go to RSVP. We truly appreciate your understanding.',
  },
  {
    id: 4,
    question: 'Are kids allowed?',
    answer: 'We love your little ones, but to allow all guests to relax and enjoy the evening, our wedding will be an adults-only celebration. We truly appreciate your understanding.',
  },
  {
    id: 5,
    question: 'What is the dress code?',
    answer: 'Our dress code is formal garden party — think floor-length dresses and suits with a colorful, elegant twist. We encourage vibrant colors, florals, and classic silhouettes that feel polished and festive. Please no jeans. For our female guests, we kindly ask to avoid white, beige, champagne, and ivory to keep the bride’s look unique. We can’t wait to see your beautiful outfits!',
  },
  {
    id: 6,
    question: "What should I do if I can't make it?",
    answer: 'We\'ll miss you! If you know you can\'t attend, please RSVP "No" on the website. If you\'ve already submitted your RSVP and something changes, you can update your response anytime before February 28, 2026 by returning to the RSVP page. Thanks so much!',
  },
  {
    id: 7,
    question: 'Will the ceremony be outdoors?',
    answer: 'Yes, the ceremony will be held outdoors with a beautiful garden backdrop. We have a covered backup plan in case of rain.',
  },
  {
    id: 8,
    question: 'What about gifts?',
    answer: 'Your presence is the greatest gift! If you wish to give a gift, we have a registry available on the Registry page, or a contribution to our honeymoon fund would be greatly appreciated.',
  },
]

export function QA() {
  const [openItems, setOpenItems] = useState<number[]>([])

  const toggleItem = (id: number) => {
    setOpenItems(prev => 
      prev.includes(id) 
        ? prev.filter(item => item !== id)
        : [...prev, id]
    )
  }

  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="section-padding">
        <div className="container-max">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-serif text-primary-900 mb-4">
              Questions & Answers
            </h1>
            <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
              Here are answers to some frequently asked questions about our wedding. 
              If you have any other questions, please don't hesitate to reach out!
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="space-y-4">
              {faqs.map((faq) => (
                <div key={faq.id} className="card">
                  <button
                    onClick={() => toggleItem(faq.id)}
                    className="w-full text-left p-6 flex items-center justify-between hover:bg-neutral-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-primary-900 pr-4">
                      {faq.question}
                    </h3>
                    {openItems.includes(faq.id) ? (
                      <ChevronUp className="h-5 w-5 text-primary-600 flex-shrink-0" />
                    ) : (
                      <ChevronDown className="h-5 w-5 text-primary-600 flex-shrink-0" />
                    )}
                  </button>
                  
                  {openItems.includes(faq.id) && (
                    <div className="px-6 pb-6">
                      <p className="text-neutral-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="mt-12">
            <div className="card p-8 text-center max-w-2xl mx-auto">
              <h3 className="text-2xl font-serif text-primary-900 mb-4">
                Still have questions?
              </h3>
              <p className="text-neutral-600 mb-6">
                We're here to help! If you have any other questions about our wedding, 
                please don't hesitate to reach out to us directly.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="mailto:naetzy@gmail.com"
                  className="btn-primary"
                >
                  Contact the Bride
                </a>
                <a
                  href="mailto:eduardo.rios.jr.7@gmail.com"
                  className="btn-secondary"
                >
                  Contact the Groom
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
} 